import { Box } from '@mui/material';

type HomeLabelBadgeProps = {
  badgeContent: number | string;
};
export const HomeLabelBadge = ({ badgeContent }: HomeLabelBadgeProps) => {
  return (
    <Box
      sx={{
        ml: 2,
        backgroundColor: '#d9338d',
        borderRadius: '50%',
        width: 26,
        height: 26,
        color: '#fff',
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
      }}
    >
      {badgeContent}
    </Box>
  );
};
